import React from "react";
import content from "@/data/content.json";
import { AccentH2, Container, Label, Reveal, Section } from "./Primitives";
import { FlowLines } from "./FlowLines";

const { methode } = content;

export const Methode = () => (
  <Section id="methode" testId="section-methode" className="has-lines overflow-hidden">
    <FlowLines color="#0F9D6E" opacity={[0.035, 0.028]} />
    <Container>
      <div className="grid grid-cols-1 gap-14 lg:grid-cols-[1.15fr_0.85fr] lg:gap-20">
        <div>
          <Reveal>
            <Label>{methode.label}</Label>
            <AccentH2 className="mt-6 max-w-[520px] font-bold text-[#1e2532]">{methode.h2}</AccentH2>
          </Reveal>

          <ol className="mt-12 border-t border-[#dfe2e0]">
            {methode.steps.map((s, i) => (
              <Reveal key={s.num} delay={i * 0.08}>
                <li
                  data-testid={`methode-step-${i}`}
                  className="grid grid-cols-[64px_1fr] gap-4 border-b border-[#dfe2e0] py-9 md:grid-cols-[110px_1fr] md:gap-8"
                >
                  <span className="font-display text-[26px] font-bold leading-none text-[#0f9d6e] md:text-[34px]">
                    {s.num}
                  </span>
                  <div>
                    <h3 className="font-semibold text-[#1e2532]">{s.h3}</h3>
                    <p className="mt-4 max-w-[580px] text-[16.5px] leading-[1.78] text-[#565f70]">{s.text}</p>
                  </div>
                </li>
              </Reveal>
            ))}
          </ol>
        </div>

        <div className="relative hidden lg:block">
          <div className="img-frame media-sticky sticky top-[110px] overflow-hidden">
            <img
              src={methode.image}
              alt={methode.imageAlt}
              loading="eager"
              decoding="async"
              width="900"
              height="900"
              className="h-full w-full"
            />
          </div>
        </div>
      </div>
    </Container>
  </Section>
);
